import React, { useEffect, useState } from "react";
import { studentcountcheck, studentlist, studentuploadbulk } from "../../../services/student";
import { AgGridReact } from "ag-grid-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function Allstudent() {
  const [studata, setStudata] = useState([]);

  const [urllink, setUrllink] = useState("");

  const navigate = useNavigate();
  const columnDefs = [
    {
      headerName: "Actions",
      width: 100,
      field: "id",
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => navigate(`/student/studentdetail/${params.value}`)}
              className="btn-sm btn-info me-2"
              title="Edit Student"
            >
              <i className="fa fa-edit"></i>
            </a>

            <a
              onClick={() => navigate(`/student/profile/${params.value}`)}
              className="btn-sm btn-success"
              title="Student Profile"
            >
              <i className="fa fa-user"></i>
            </a>
          </div>
        );
      },
    },
    {
      headerName: "Photo",
      width: 100,
      field: "photo",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        if(params.value !== null){
         
          return (
            <div className="text-center">
              <img
                src={params.data.path + params.value}
                onError={(ev) => errorphoto(ev)}
                style={{ height: "60px", width: "60px" }}
              />
            </div>
          );
        }else{
          return (
            <div className="text-center">
              <img
                src={require("../../../assets/images/user.png")}
                style={{ height: "60px", width: "60px" }}
              />
            </div>
          );
        }
       
      },
    },

    {
      headerName: "Student",
      width: 150,
      field: "student_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Username",
      width: 150,
      field: "username",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
   
    {
      headerName: "Academic Year",
      width: 120,
      field: "year_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Class",
      width: 110,
      field: "class_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Section",
      width: 110,
      field: "section_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Mobile",
      width: 120,
      field: "phone",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "State",
      width: 120,
      field: "state_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "District",
      width: 120,
      field: "district",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "City",
      width: 120,
      field: "city",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Academy",
      width: 150,
      field: "academy_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  function errorphoto(ev) {
    ev.target.src = require("../../../assets/images/user.png");
    ev.target.onerror = null;
  }

  const location = useLocation();
  const [scnt, setSCnt] = useState("");
  useEffect(() => {
    const path = location.pathname.split("/")[2]; // Extracts 'allstudent' or 'leftstudentlist'
    setUrllink(path);
    if (localStorage.getItem("Role") !== "1") {
      studentcountcheck().then((res) => {
        if (res.status === false) {
          setSCnt(res.message);
        }
      });
    }

    if (path === "allstudent") {
      studentlist(1).then((res) => {
        if (res.status === true) {
          setStudata(res.data.details);
        }
      });
    } else if (path === "leftstudentlist") {
      studentlist(2).then((res) => {
        if (res.status === true) {
          setStudata(res.data.details);
        }
      });
    } else if (path === "deletestudentlist") {
      studentlist(3).then((res) => {
        if (res.status === true) {
          setStudata(res.data.details);
        }
      });
    }

   
  }, [location.pathname]);

  function checkstu() {
    if (scnt !== "") {
      toast.error(scnt);
    } else {
      navigate("/student/addstudents");
    }
  }



  return (
    <div>
      <div className="page-header">
        {urllink === "allstudent" && (
          <>
            <h2 className="main-content-title tx-24 mg-b-5">All Students</h2>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a>Students</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                All Students
              </li>
            </ol>
          </>
        )}

        {urllink === "leftstudentlist" && (
          <>
            <h2 className="main-content-title tx-24 mg-b-5">Left Students</h2>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a>Students</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Left Students
              </li>
            </ol>
          </>
        )}

        {urllink === "deletestudentlist" && (
          <>
            <h2 className="main-content-title tx-24 mg-b-5">Delete Students</h2>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a>Students</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Delete Students
              </li>
            </ol>
          </>
        )}
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="card custom-card mg-b-20">
                <div className="card-body">
                  <div className="text-right">
                    {(localStorage.getItem("Role") === "1" ||
                      localStorage.getItem("Role") === "2" || localStorage.getItem("Role") === "5") && (
                      <>
                        <a onClick={checkstu} className="btn btn-success me-2">
                          Add New Student
                        </a>

                      
                      </>
                    )}

                    {urllink === "leftstudentlist" && (
                      <Link
                        to="/student/leftstudent"
                        className="btn btn-secondary"
                      >
                        Add Left Student
                      </Link>
                    )}
                    {urllink === "deletestudentlist" && (
                      <Link
                        to="/student/deletestudent"
                        className="btn btn-secondary"
                      >
                        Add Delete Student
                      </Link>
                    )}
                  </div>

                  <div className="ag-theme-alpine ag-style mt-2">
                    <AgGridReact
                      columnDefs={columnDefs}
                      rowData={studata}
                      pagination="true"
                      paginationPageSize="10"
                      sortingOrder={["asc", "desc"]}
                      suppressDragLeaveHidesColumns={true}
                    />
                  </div>
                </div>
              </div>

             
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
